import * as React from "react";
import type { SVGProps } from "react";
const SvgFoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="fold_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M298.667 512a42.667 42.667 0 0 1 42.666-42.667h341.334a42.667 42.667 0 1 1 0 85.334H341.333A42.667 42.667 0 0 1 298.667 512zM85.333 256A170.667 170.667 0 0 1 256 85.333h512A170.667 170.667 0 0 1 938.667 256v512A170.667 170.667 0 0 1 768 938.667H256A170.667 170.667 0 0 1 85.333 768V256zM256 170.667A85.333 85.333 0 0 0 170.667 256v512A85.333 85.333 0 0 0 256 853.333h512A85.333 85.333 0 0 0 853.333 768V256A85.333 85.333 0 0 0 768 170.667H256z"
    />
  </svg>
);
export default SvgFoldIcon;
